<template>
    <div class="text-center">
      <UserAddIcon class="mx-auto h-12 w-12 text-gray-400" aria-hidden="true" />
      <h3 class="mt-2 text-sm font-semibold text-gray-900">Sie sind noch keinem Kunden zugeordnet.</h3>
      <p class="mt-1 text-sm text-gray-500">Jetzt mit einem Kundenkonto verknüpfen. Sie benötigen ggf. Ihre letzte Abbuchung.</p>
      <div class="mt-6">
        <button type="button" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          <PlusIcon class="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
          Mit Kundenkonto verknüpfen
        </button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { PlusIcon, UserAddIcon } from '@heroicons/vue/solid'
  </script>